export default "__VITE_ASSET__CerykDLR__"